import { useState, useEffect } from 'react';
import { Alert, Slide } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return (
    <Slide direction="down" in={isOffline} mountOnEnter unmountOnExit>
      <Alert
        severity="warning"
        icon={<WifiOffIcon />}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          borderRadius: 0,
          justifyContent: 'center',
        }}
      >
        אין חיבור לאינטרנט
      </Alert>
    </Slide>
  );
};

export default OfflineBanner;
